export default __webpack_public_path__ + "static/media/3.c19be16d.png";